/**
 * Business manifests, indexed by CAD model.
 *
 * Manifests live in `libs/shared` rather than in the frontend so that a single copy serves both the
 * viewer and the converter's `--check-model` verification. They are plain typed modules on purpose:
 * a hand-edited `CadModelManifest` is type-checked by `tsc`, so a typo in a field name or an
 * `explodeVector` of the wrong arity fails the build instead of silently doing nothing.
 *
 * The viewer never reads this registry itself: the page passes the parts in. That keeps the door
 * open for the API to serve manifests later without touching the component.
 */

import {CadModelManifest} from '@shared/models/cad_model';
import {MAVIROLL_CONNECT_MANIFEST} from '@shared/models/cad/maviroll_connect_manifest';
import {DoorCadModelKey} from '@shared/models/door_cad_registry';

export const DOOR_CAD_MANIFESTS: Record<DoorCadModelKey, CadModelManifest> = {
  'maviroll-connect': MAVIROLL_CONNECT_MANIFEST,
};

export function getDoorCadManifest(key: DoorCadModelKey): CadModelManifest {
  return DOOR_CAD_MANIFESTS[key];
}
